var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form',[_c('v-file-input',{staticClass:"importerMenu",attrs:{"prepend-icon":"mdi-file-upload-outline","hide-input":"","dense":"","hint":_vm.$t('menu.importCsv')},on:{"change":_vm.fileChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }